// extracted by mini-css-extract-plugin
export default {"paymentErrorModal":"payment-error-modal_paymentErrorModal__f2L-m","shown":"payment-error-modal_shown__6Ey6C","modal":"payment-error-modal_modal__g8k+I"};